import { Chip, Icon } from "@outschool/backpack";
import { faCheck, faMinus, faTimes } from "@outschool/icons";
import React from "react";

export default function LearnerConsentChip({
  consentStatus,
}: {
  consentStatus: boolean | null;
}) {
  return (
    <Chip
      size="small"
      color={
        consentStatus
          ? "success"
          : consentStatus === false
          ? "warning"
          : "neutral"
      }
      label={
        consentStatus
          ? "Allowed"
          : consentStatus === false
          ? "Not Allowed"
          : "Not Set"
      }
      icon={
        <Icon
          icon={
            consentStatus
              ? faCheck
              : consentStatus === false
              ? faTimes
              : faMinus
          }
        />
      }
    />
  );
}
